import { createSlice } from '@reduxjs/toolkit';

import { INITIAL_WORKLIST_INTEGRATIONS_STATE } from './worklist.state';

const slice = createSlice({
  name: 'worklistIntegrations',
  initialState: INITIAL_WORKLIST_INTEGRATIONS_STATE,
  reducers: {},
});

export const integrationsWorklistReducer = slice.reducer;

export const WorklistIntegrationsActions = {
  ...slice.actions,
};
